<mat-card *ngIf="problem() as problem; else loading">
  <mat-card-header>
    <mat-card-title>{{problem.title | capitalize}}</mat-card-title>
    <a mat-button (click)="onEditProblem()" color="primary">Edit</a>
  </mat-card-header>
  <mat-card-content>
    <mat-card>
      <mat-card-content>
        <!-- TODO: Populate from data model -->
        <mat-card-subtitle class="student">Display Name</mat-card-subtitle>
        <p>Problem Display Name</p>

        <mat-card-subtitle class="student">Subject</mat-card-subtitle>
        <p>{{problem.topic.subject}}</p>

        <mat-card-subtitle class="student">Topic</mat-card-subtitle>
        <p>{{problem.topic.displayName}}</p>

        <mat-card-subtitle class="student">Content</mat-card-subtitle>
        <app-ck-editor [readonlyData]=problem.content [inline]="true" [readonly]="true"></app-ck-editor>

        <div *ngIf="problem.passage">
          <mat-card-subtitle class="student">
            {{problem.passage.title}}
            <a mat-button [routerLink]="['/passages/' + problem.passage.id + '/edit']" color="primary">Edit</a>
          </mat-card-subtitle>
          <app-ck-editor [readonlyData]=problem.passage.content [inline]="true" [readonly]="true"></app-ck-editor>
        </div>

        <!-- TODO: Populate from data model -->
        <mat-card-subtitle class="student">Explanation</mat-card-subtitle>
        <p>Problem Explanation lorem ipsum dolor</p>
      </mat-card-content>
    </mat-card>

    <!--Solution List-->
    <app-solution-list class="section-card" [solutions]="problem.solutions"></app-solution-list>
    <!--End Solution-->

    <mat-card class="section-card">
      <mat-card-header>
        <mat-card-title>Exercises</mat-card-title>
      </mat-card-header>

      @if (problem.exercises?.length) {
        <mat-card-content>
          <mat-accordion>
            @for (exercise of problem.exercises; track exercise.id) {
              <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{exercise.title}}
                  </mat-panel-title>
                  <button mat-button color="primary"
                          (click)="onManageExercise(exercise)">
                    Manage
                  </button>
                </mat-expansion-panel-header>

                <mat-list>
                  <mat-list-item class="w-50">
                    <h3 mat-line>{{exercise.subject}}</h3>
                    <p mat-line class="secondary-text">Subject</p>
                  </mat-list-item>
                  <mat-list-item class="w-50">
                    <h3 mat-line>{{exercise.description}}</h3>
                    <p mat-line class="secondary-text">Description</p>
                  </mat-list-item>
                </mat-list>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </mat-card-content>
      }
    </mat-card>
  </mat-card-content>
</mat-card>

<ng-template #loading>
  <app-spinner></app-spinner>
</ng-template>
